import React, { useEffect, useState } from "react";

import type { LinearIconName } from "./LinearIconNames";

export interface LinearExtendIconProps extends LinearIconProps {
	name: LinearIconName;
}

export interface LinearIconProps extends React.SVGProps<SVGSVGElement> {
	size?: number | string;
    color?: string;
    fill?: string;
	style?: React.CSSProperties;
}

export function LinearIcon({ name, size = 20, color = "currentColor", fill , ...props }: LinearExtendIconProps) {
	const [Icon, setIcon] = useState<React.FC<React.SVGProps<SVGSVGElement>> | null>(null);

	useEffect(() => {
        import(`./linearicons/files/${name}.svg`)
			.then((mod) => setIcon(() => mod.ReactComponent ?? mod.default))
			.catch((error) => console.error("SVG import error:", error));
	}, [name]);

	if (!Icon) return null;

	return (
        <Icon
            {...props}
			width={size}
			height={size}
			style={{
				...props.style,
                fill: fill ?? color,
				color,
			}}
		/>
	);
}
